import React from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { CategoryTitle, CheckboxGroup, ContainerCategory, Separator } from './styles.js';
import OptionInput from '../../../OptionButton';
import ToggleButton from '../../../commons/ToggleButton';

const Category = ({
  id,
  options,
  device,
  features,
  onChange,
  registerRef,
  getMaxHeight,
  isCollapsed,
  setCollapsed,
  visibleCount
}) => {
  const { t } = useTranslation();
  // Verificar si una característica está seleccionada
  const isFeatureSelected = featureId => {
    if (!features) return false;
    const feature = features.find(f => f.id === featureId);
    return feature ? feature.isChecked : false;
  };

  return (
    <ContainerCategory data-publi={`checkbox-category-${id}`} device={device}>
      <CategoryTitle data-publi='checkbox-categories-title'>{t(`professionalPubli.extras.${id}`)}</CategoryTitle>
      <div className='section'>
        <CheckboxGroup
          ref={element => registerRef(id, element)}
          maxHeight={getMaxHeight(id)}
          twoRows={options.length > 3}
          device={device}
        >
          {options.map(feature => (
            <OptionInput
              key={feature.id}
              itemSelector='feature-item'
              device={device}
              name={`feature-${feature.id}`}
              value={feature.id}
              selected={isFeatureSelected(feature.id)}
              onChange={() => onChange(feature.id, !isFeatureSelected(feature.id))}
              label={feature.name}
              withTooltip
            />
          ))}
        </CheckboxGroup>
        {options.length > visibleCount && (
          <ToggleButton
            dataPubli='extras-showMore'
            device={device}
            title={t(`professionalPubli.extras.toggle.${isCollapsed(id) ? 'showMore' : 'showLess'}`)}
            active={!isCollapsed(id)}
            setActive={() => setCollapsed(id)}
            margin='12px 13px 0 0'
            widthIcon='10px'
            heightIcon='6.1px'
          />
        )}
        {device !== 'mobile' && <Separator />}
      </div>
    </ContainerCategory>
  );
};

export default React.memo(Category);

Category.propTypes = {
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      name: PropTypes.string.isRequired
    })
  ).isRequired,
  device: PropTypes.string,
  features: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      isChecked: PropTypes.bool
    })
  ),
  onChange: PropTypes.func.isRequired,
  registerRef: PropTypes.func.isRequired,
  getMaxHeight: PropTypes.func.isRequired,
  isCollapsed: PropTypes.func.isRequired,
  setCollapsed: PropTypes.func.isRequired
};
